export default [
    {
        value: '#fffffe',
        label: 'white #001',
        index: 1,
    },
    {
        value: '#f7ff00',
        label: 'florescent yellow #002',
        index: 2,
    },
    {
        value: '#ff002b',
        label: 'florescent orange #003',
        index: 3,
    },
    {
        value: '#ff1aae',
        label: 'florescent pink #004',
        index: 4,
    },
    {
        value: '#6cff30',
        label: 'florescent green #005',
        index: 5,
    },
    {
        value: '#1a1814',
        label: 'black #006',
        index: 6,
    },
    {
        value: '#817776',
        label: 'dark gray #007',
        index: 7,
    },
    {
        value: '#dbdad1',
        label: 'silver gray #008',
        index: 8,
    },
    {
        value: '#37e8f8',
        label: 'sky blue #009',
        index: 9,
    },
    {
        value: '#093ddb',
        label: 'royal blue #010',
        index: 10,
    },
    {
        value: '#120f8a',
        label: 'ultramarine blue #011',
        index: 11,
    },
    {
        value: '#ffe809',
        label: 'yellow #012',
        index: 12,
    },
    {
        value: '#ffb522',
        label: 'gold #013',
        index: 13,
    },
    {
        value: '#ff552b',
        label: 'orange #014',
        index: 14,
    },
    {
        value: '#ea0404',
        label: 'red #015',
        index: 15,
    },
    {
        value: '#a90e0e',
        label: 'crimson red #016',
        index: 16,
    },
    {
        value: '#430f92',
        label: 'purple #019',
        index: 19,
    },
    {
        value: '#079d90',
        label: 'grass green #020',
        index: 20,
    },
    {
        value: '#f6d6af',
        label: 'skin #023',
        index: 23,
    },
    {
        value: '#5bb324',
        label: 'forest green #024',
        index: 24,
    },
];
